import {Box, Typography} from '@mui/material';
import './GroupNameComponent.scss';

interface GroupNameComponentProps {
  name: string;
  count: number;
  isSelected: boolean;
  dataTestId?: string;
  onClick?: () => void;
}

const GroupNameComponent: React.FC<GroupNameComponentProps> = ({
  name,
  count,
  isSelected,
  dataTestId,
  onClick,
}) => {
  return (
    <Box
      className={`group-panel-item ${isSelected ? 'selected' : ''}`}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <Box className="item-content" tabIndex={0}>
        <Typography
          className="item-name typo-text label2_size"
          data-testid={`group-name-${dataTestId}`}
        >
          {name}
        </Typography>
        <Typography
          className="item-count typo-text label2_size"
          data-testid={`group-name-count-${dataTestId}`}
        >
          ({count})
        </Typography>
      </Box>
    </Box>
  );
};

export default GroupNameComponent;
